import StarterKit from '@tiptap/starter-kit';
import { Markdown } from '@tiptap/markdown';
import Image from '@tiptap/extension-image';
import { Table } from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableHeader from '@tiptap/extension-table-header';
import TableCell from '@tiptap/extension-table-cell';
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import FileHandler from '@tiptap/extension-file-handler';

const NOTE_IMAGE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp', 'image/avif'];
const REMOTE_IMAGE_PROTOCOLS = new Set(['http:', 'https:']);

const getImageAttributesFromHtml = pasteContent => {
    if (typeof pasteContent !== 'string' || !pasteContent.includes('<img') || typeof DOMParser === 'undefined') {
        return null;
    }

    const document = new DOMParser().parseFromString(pasteContent, 'text/html');
    const image = document.querySelector('img[src]');

    if (!image) {
        return null;
    }

    const src = String(image.getAttribute('src') || '').trim();
    if (!src) {
        return null;
    }

    try {
        const parsedUrl = new URL(src, window.location.origin);
        if (!REMOTE_IMAGE_PROTOCOLS.has(parsedUrl.protocol)) {
            return null;
        }
    } catch (error) {
        return null;
    }

    return {
        src,
        alt: image.getAttribute('alt') || undefined,
        title: image.getAttribute('title') || undefined
    };
};

const insertImageFromHtml = (editor, pasteContent) => {
    const imageAttributes = getImageAttributesFromHtml(pasteContent);
    if (!imageAttributes) {
        return false;
    }

    return editor.chain().focus().setImage(imageAttributes).run();
};

export const createNoteEditorExtensions = () => [
    StarterKit,
    Image.configure({
        HTMLAttributes: {
            loading: 'lazy'
        }
    }),
    Table.configure({
        renderWrapper: true
    }),
    TableRow,
    TableHeader,
    TableCell,
    TaskList,
    TaskItem.configure({
        nested: true
    }),
    FileHandler.configure({
        allowedMimeTypes: NOTE_IMAGE_MIME_TYPES,
        onPaste: (editor, files, pasteContent) => {
            if (!files.length || !pasteContent) {
                return;
            }

            insertImageFromHtml(editor, pasteContent);
        }
    }),
    Markdown.configure({
        markedOptions: {
            gfm: true
        }
    })
];
